<template>
  <FieldBox :title="$t('trade.order-trail2-price-gap-label')">
    <PlusMinusInput
      v-model="trailingPrice"
      :precision="precision"
      :step="minTick"
      :min="0"
      :max="999999999"
      :match-tick="true"
      :match-precision="true"
    />
  </FieldBox>
</template>
<script>
import { mapGetters } from 'vuex'
import PlusMinusInput from 'com/PlusMinusInput'
import FieldBox from '../FieldBox'
import getPriceAccuracy from 'utils/getPriceAccuracy'
import { TRADING_STATUS } from 'const/stock'

export default {
  components: { PlusMinusInput, FieldBox },
  props: {
    minTicks: Array
  },
  computed: {
    ...mapGetters(['tradeRequest']),
    order() {
      return this.tradeRequest.order
    },
    stock() {
      return this.tradeRequest.stock
    },
    latestPrice() {
      if (this.stock.tradingStatus === TRADING_STATUS.TRADING) {
        return this.stock.latestPrice
      }
      return this.stock.hourTradingLatestPrice || this.stock.latestPrice
    },
    minTick() {
      const price = Number(this.latestPrice)
      for (let i = 0; i < this.minTicks.length; i++) {
        const tick = this.minTicks[i]
        if (price >= tick.begin && price < tick.end) {
          return tick.tickSize || tick.minTick
        }
      }
      return 0
    },
    precision() {
      return getPriceAccuracy(this.minTick)
    },
    trailingPrice: {
      get() {
        return this.order.trailingPrice
      },
      set(trailingPrice) {
        this.$store.dispatch('updateTradeOrder', {
          trailingPrice
        })
      }
    }
  }
}
</script>
